<template>
  <CardInside
    data-el="getting-start-card"
    help-title="👋 Welcome" help-no-icon>
    <template #body>
      <ApiKey v-if="user" />
      <CodeSamples :user="user" />
    </template>
    <template #help>
      <YoutubeVideo
        video-id="D8D5ts14RUY"
        thumbnail-src="https://public.getmailslurp.com/video-screenshots/welcome-to-mailslurp.jpeg"
      />
      <p>
        Watch this short tutorial or see our
        <a
          class="text-link"
          target="_blank"
          href="https://docs.mailslurp.com/guides/"
          >getting started</a
        >
        guides and
        <a class="text-link" href="https://docs.mailslurp.com" target="_blank"
          >developer documentation</a
        >
        to learn more.
      </p>
    </template>
  </CardInside>
</template>
<script setup lang="ts">
import ApiKey from '../../components/form/ApiKey.vue';
import CodeSamples from '../../components/form/CodeSamples.vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import CardInside from '../../components/form/CardInside.vue';
import YoutubeVideo from '../video/YoutubeVideo.vue';

const store3 = useStore3();

const { user } = storeToRefs(store3);
</script>
<style scoped>
.doc-link img {
  height: 40px;
}
</style>
